import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";

interface LockedBadgeProps {
  tier: "upgrade" | "enterprise";
  /** Override the default plan-modal open — e.g. open a feature upgrade modal first
   *  (which then opens the plan modal itself). Defaults to opening the plan modal with
   *  no context (no pill), since this badge isn't tied to one gated feature. */
  onClick?: () => void;
}

export function LockedBadge({ tier, onClick }: LockedBadgeProps) {
  const { openPlanModal } = useCampaignBuilder();
  const handleClick = onClick ?? (() => openPlanModal());
  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-1 font-lato text-[10px] font-bold uppercase tracking-[1.5px] transition-opacity duration-150 hover:opacity-80 cursor-pointer"
      style={{
        padding: "5px 12px",
        borderRadius: "var(--radius-pill)",
        background: "var(--color-good-ochre-bg)",
        color: "var(--color-good-ochre)",
        border: "1px solid var(--color-good-ochre-border)",
        flexShrink: 0,
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 11 }} />
      {tier === "enterprise" ? "Enterprise" : "Upgrade"}
    </button>
  );
}
